import { FC } from 'react';

import { DrawerProps } from 'antd';

import { CustomIcon } from '@components/Dropdown/styled';
import { CloseIcon } from '@assets/icons';
import { StyledDrawer } from '@components/views/components/listing/ResponsiveListingSearchStyle';

const ResponsiveDrawer: FC<DrawerProps> = ({
  open,
  onClose,
  title = '',
  children,
  ...otherProps
}) => {
  return (
    <StyledDrawer
      title={title}
      closeIcon={
        <CustomIcon icon={CloseIcon} fontSize={24} paletteColor='black' />
      }
      placement='top'
      onClose={onClose}
      open={open}
      destroyOnClose={true}
      contentWrapperStyle={{
        height: '100%',
      }}
      {...otherProps}
    >
      {children}
    </StyledDrawer>
  );
};

export default ResponsiveDrawer;
